import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
    Button, CssBaseline, TextField, FormControlLabel, Checkbox, Link, Grid, Box, Paper,
    Typography, Container, IconButton, Alert, AlertTitle, Snackbar, LinearProgress, InputAdornment, CircularProgress
}
    from '@mui/material/';

import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

import { ThemeProvider } from '@mui/material/styles';

import { login, resetPassword, getUserProfile, logout } from "../../actions/auth";
import { clearMessage, setMessage } from "../../actions/message";
import { buildSession, updateAppState } from "../../actions/appstate";
import OTPVerification from './OTPVerification';
import { validateEmail, checkActivityIntervalTrigger, deepCopy, getCookie, getDataSources, setLodgiqCookie, getLodgiqCookie, addToLocalStorage, getOrCreateDeviceId } from "../../app/util";
//Global custom theme configuration
import theme from '../../theme';
import { loginImgBaseUrl, API_REGISTRY } from "../../app/config"
//UI Elements for login screen
import { Copyright, LoginLogo, LoginProgressbar, LoginAlertBar, LoginForm } from "../../components/layout/login-ui"
import AskLodgiqPromo from "./AskLodgiqPromo"
import { error } from 'highcharts';
import moment from 'moment';
import {
    GoogleReCaptchaProvider,
    useGoogleReCaptcha
} from 'react-google-recaptcha-v3';
import { analytics } from '../../hooks/use-analytics';
import { useOnlineStatus } from '../../hooks/helper-hooks';
import { UPDATE_STATE } from '../../actions/types';
import { generateUUID } from '../../hooks/useTabTracker';

const isRecaptchaDevBypass = process.env.NODE_ENV === 'development';

const LoginContent = () => {
    const { executeRecaptcha } = useGoogleReCaptcha();
    const isOnline = useOnlineStatus();
    const { UserProfile } = API_REGISTRY;
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isrequesting, setIsRequesting] = useState(false);
    const [resError, setResError] = useState(false);
    const [resErrorMsg, setResErrorMsg] = useState('');
    const [severity, setSeverity] = useState('error');
    const authState = useSelector(state => state.auth)
    const [errorType, setErrorType] = useState("");
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { app, auth } = useSelector((state) => state);
    const { profile, twoFactor } = auth;
    const { app_state, ui_state } = app.current_state;
    const color = theme.palette;
    const [showPassword, setShowPassword] = useState(false);
    const [showOtpScreen, setShowOtpScreen] = useState(false);

    useEffect(() => {
        let isSubscribed = true;
        // sessionStorage.clear();
        // localStorage.clear();
        if (!isOnline) {
            sessionStorage.clear();
            localStorage.clear();
            authState.profileSuccess = false;
        }
        if (isOnline && isSubscribed && authState.profileSuccess === true) {
            sessionStorage.removeItem('documentHiddenTime');
            dispatch(buildSession(authState));
            addToLocalStorage("isLoginEnabled", true);

            const today = new Date().toLocaleDateString("en-CA");
            localStorage.setItem("loginDate", today);
            navigate("/");
        }

        return () => {
            return isSubscribed = false
        }

    }, [authState.profileSuccess])

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (twoFactor?.required) return;
        setLodgiqCookie("loginCount", 0, 7);

        if (!isRecaptchaDevBypass && !executeRecaptcha) {
            setSeverity('error');
            setResError(true);
            setResErrorMsg("reCAPTCHA not ready. Please try again.");
            return;
        }

        const captchaToken = isRecaptchaDevBypass ? "local-dev-bypass" : await executeRecaptcha('login');

        setResErrorMsg("")
        dispatch(clearMessage());
        setResError(false);
        setIsRequesting(true);

        const payload = {
            email: email,
            password: password,
            user_login_type: "normal",
            ts: moment().format(),
            recaptcha_token: captchaToken,
            device_id: await getOrCreateDeviceId('browser'),
        };

        dispatch(login(payload))
            .then((data) => {
                if (data?.twoFactorRequired) {
                    setIsRequesting(false);
                    setShowOtpScreen(true);
                    return;
                }
                const token = data?.auth_tokens?.session?.key;
                const { user_id, email } = data;
                let count = getLodgiqCookie("loginCount");
                count = count ? parseInt(count) + 1 : 1;
                setLodgiqCookie("loginCount", count, 7);

                const succssData = deepCopy(data);
                succssData.token = "*********";

                analytics.amplitude.setUserId(email);
                analytics.track("login_success", succssData);

                analytics.track("login_success", {
                    user_id: user_id,
                    user_login_type: 'password',
                    platform: 'web',
                });

                dispatch(getUserProfile({ api: UserProfile.uri, request: { ...UserProfile.payload, token_string: token, user_id: user_id } }))
                    .then((rs) => {

                        if (rs && rs.status === 'success') {

                            setIsRequesting(false);
                            // navigate("/");
                            setErrorType("")

                        }
                    }).catch((err) => {
                        console.log(err);
                        if (err && err.original) {
                            setIsRequesting(false);
                            setSeverity('error');
                            setResError(true);
                            setResErrorMsg(err.original.statusText);
                        } else {
                            let errorTxt = toString(err);
                            setIsRequesting(false);
                            setSeverity('error');
                            setResError(true);
                            setResErrorMsg(errorTxt);
                        }
                    });
            }).catch((msg) => {
                setSeverity('error');
                setIsRequesting(false);
                setResError(true);
                setResErrorMsg(msg);
                if (msg) {
                    if (msg.toLowerCase().includes('invalid email')) {
                        //#endregion
                        setErrorType("email")
                    }
                    else if (msg === "Wrong password") {
                        setErrorType("password")
                    }
                    //Record for amplitude analytics purposes
                    analytics.track("login_fail", {
                        email: email,
                        password: '******',
                        user_login_type: "normal",
                        ts: moment().format(),
                        cause: msg
                    });
                }
            });

    };
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setResError(false);
    };
    const [isForgetPassword, setIsForgetPassword] = React.useState(false);
    const gotToForgotPassword = () => {
        setIsForgetPassword(true);
    };
    const gotToLogin = () => {
        setIsForgetPassword(false);

    };
    const [resetPassEmail, setResetPassEmail] = useState('');
    const requestPassword = async (event) => {
        event.preventDefault();
        if (!validateEmail(resetPassEmail)) {
            setSeverity('error');
            setResError(true);
            setResErrorMsg("Please Enter Valid Email");
            return;
        }

        if (!isRecaptchaDevBypass && !executeRecaptcha) {
            setSeverity('error');
            setResError(true);
            setResErrorMsg("reCAPTCHA not ready. Please try again.");
            return;
        }

        const captchaToken = isRecaptchaDevBypass ? "local-dev-bypass" : await executeRecaptcha('reset_password');

        setIsRequesting(true);
        dispatch(clearMessage());
        setResError(false);
        const payload = {
            email: resetPassEmail,
            recaptcha_token: captchaToken
        };
        dispatch(resetPassword(payload))
            .then((rs) => {
                setSeverity('success');
                setResError(true);
                setResErrorMsg("Please check your inbox to set new password, Thanks!");
                setIsRequesting(false);
                setErrorType("")
                setIsForgetPassword(false);
            }).catch((msg) => {
                setSeverity('error');
                setIsRequesting(false);
                setResError(true);
                setResErrorMsg(msg);
            });
    };

    return (

        <ThemeProvider theme={theme}>
            <Grid container component="main" sx={{ height: '100vh' }}>
                <CssBaseline />

                <Grid className='loginMainContainer' item xs={12} sm={8} md={5} component={Paper} elevation={6} square sx={{ position: 'relative' }}>

                    <Box sx={{ width: '100%', position: 'absolute', zIndex: 999 }}>
                        {isrequesting && <LinearProgress sx={{ position: 'absolute', width: '100%' }} color='green' />}
                        <LoginAlertBar className='loginAlertBar' resError={resError} handleClose={handleClose} resErrorMsg={resErrorMsg} severity={severity}>
                            <AlertTitle>{resErrorMsg}</AlertTitle>
                        </LoginAlertBar>
                    </Box>

                    {/* Logo part */}
                    <Box className='loginHeader'>
                        <LoginLogo />
                    </Box>


                    {/* Body part */}
                    <Box className='loginBody'>

                        <Box component="form" noValidate onSubmit={handleSubmit}>
                            <Container className='loginBodyMain' component="main" maxWidth="xs">

                                <Box className='letsGetStarted'>
                                    {twoFactor?.required
                                        ? <Typography sx={{ fontWeight: 700, fontSize: 22, color: '#333', mb: 0 }}>Let's secure your account</Typography>
                                        : <svg width="195" height="23" viewBox="0 0 195 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.1133 14.918V18H0.0507812V1.08984H3.58984V14.918H11.1133ZM18.9883 7.40625C18.1992 7.40625 17.5469 7.66016 17.0312 8.16797C16.5234 8.67578 16.2383 9.34766 16.1758 10.1836H21.6836C21.6445 9.32422 21.3828 8.64844 20.8984 8.15625C20.4219 7.65625 19.7852 7.40625 18.9883 7.40625ZM21.7539 14.3203H24.9297C24.6719 15.5469 24.0156 16.5156 22.9609 17.2266C21.9141 17.9297 20.6016 18.2812 19.0234 18.2812C17.0547 18.2812 15.5195 17.6953 14.418 16.5234C13.3164 15.3438 12.7656 13.7031 12.7656 11.6016C12.7656 9.5 13.3203 7.83984 14.4297 6.62109C15.5391 5.40234 17.0547 4.79297 18.9766 4.79297C20.8828 4.79297 22.3672 5.36719 23.4297 6.51562C24.5 7.66406 25.0352 9.26562 25.0352 11.3203V12.3633H16.1641V12.5391C16.1875 13.5 16.4609 14.2617 16.9844 14.8242C17.5156 15.3789 18.2266 15.6562 19.1172 15.6562C19.7891 15.6562 20.3516 15.543 20.8047 15.3164C21.2578 15.082 21.5742 14.75 21.7539 14.3203ZM28.8086 2.00391H32.2188V5.20312H34.9023V7.88672H32.2188V13.6992C32.2188 14.2617 32.3516 14.6758 32.6172 14.9414C32.8906 15.207 33.3164 15.3398 33.8945 15.3398C34.2773 15.3398 34.6133 15.3242 34.9023 15.293V17.8945C34.3789 17.9961 33.8086 18.0469 33.1914 18.0469C31.6211 18.0469 30.4961 17.7734 29.8164 17.2266C29.1445 16.6797 28.8086 15.7734 28.8086 14.5078V7.88672H26.793V5.20312H28.8086V2.00391ZM40.75 8.26172H37.8203V1.08984H40.75V8.26172ZM43.9492 8.87109C43.9492 7.64453 44.4414 6.66016 45.4258 5.91797C46.418 5.16797 47.7188 4.79297 49.3281 4.79297C50.9688 4.79297 52.2539 5.125 53.1836 5.78906C54.1211 6.45312 54.6367 7.40234 54.7305 8.63672H51.5781C51.4922 8.21484 51.2539 7.88672 50.8633 7.65234C50.4805 7.41016 49.9766 7.28906 49.3516 7.28906C48.7344 7.28906 48.2266 7.41797 47.8281 7.67578C47.4297 7.92578 47.2305 8.25391 47.2305 8.66016C47.2305 8.97266 47.3711 9.23438 47.6523 9.44531C47.9336 9.64844 48.375 9.81641 48.9766 9.94922L51.4023 10.4766C52.6602 10.75 53.5781 11.168 54.1562 11.7305C54.7422 12.293 55.0352 13.0547 55.0352 14.0156C55.0352 15.2969 54.5117 16.3281 53.4648 17.1094C52.418 17.8906 51.043 18.2812 49.3398 18.2812C47.6367 18.2812 46.2891 17.9453 45.2969 17.2734C44.3047 16.6016 43.75 15.6445 43.6328 14.4023H46.9609C47.2344 15.3242 48.0508 15.7852 49.4102 15.7852C50.0742 15.7852 50.6133 15.6602 51.0273 15.4102C51.4414 15.1523 51.6484 14.8164 51.6484 14.4023C51.6484 14.082 51.5195 13.8242 51.2617 13.6289C51.0039 13.4258 50.5898 13.2617 50.0195 13.1367L47.6758 12.6094C46.418 12.3359 45.4805 11.8945 44.8633 11.2852C44.2539 10.668 43.9492 9.86328 43.9492 8.87109ZM71.9336 14.1328C72.457 13.4688 72.7188 12.5664 72.7188 11.4258C72.7188 10.2852 72.4531 9.38281 71.9219 8.71875C71.3984 8.05469 70.6797 7.72266 69.7656 7.72266C68.8516 7.72266 68.1367 8.05469 67.6211 8.71875C67.1133 9.375 66.8594 10.2734 66.8594 11.4141C66.8594 12.5625 67.1133 13.4688 67.6211 14.1328C68.1289 14.7891 68.8438 15.1172 69.7656 15.1172C70.6875 15.1172 71.4102 14.7891 71.9336 14.1328ZM69.7188 22.8984C68.0156 22.8984 66.6289 22.5508 65.5586 21.8555C64.4961 21.168 63.9102 20.2539 63.8008 19.1133H67.1758C67.2617 19.5117 67.5352 19.8281 67.9961 20.0625C68.457 20.2969 69.0547 20.4141 69.7891 20.4141C70.7031 20.4141 71.4141 20.2109 71.9219 19.8047C72.4297 19.4062 72.6836 18.8438 72.6836 18.1172V15.7266H72.4727C71.7383 17.1172 70.4414 17.8125 68.582 17.8125C66.9727 17.8125 65.6992 17.2383 64.7617 16.0898C63.8242 14.9336 63.3555 13.3789 63.3555 11.4258C63.3555 9.41797 63.8281 7.82422 64.7734 6.64453C65.7266 5.45703 67.0195 4.86328 68.6523 4.86328C69.5273 4.86328 70.3125 5.06641 71.0078 5.47266C71.7109 5.87891 72.2344 6.4375 72.5781 7.14844H72.7891V5.07422H76.0938V17.9531C76.0938 19.4688 75.5195 20.6719 74.3711 21.5625C73.2227 22.4531 71.6719 22.8984 69.7188 22.8984ZM85.1055 7.40625C84.3164 7.40625 83.6641 7.66016 83.1484 8.16797C82.6406 8.67578 82.3555 9.34766 82.293 10.1836H87.8008C87.7617 9.32422 87.5 8.64844 87.0156 8.15625C86.5391 7.65625 85.9023 7.40625 85.1055 7.40625ZM87.8711 14.3203H91.0469C90.7891 15.5469 90.1328 16.5156 89.0781 17.2266C88.0312 17.9297 86.7188 18.2812 85.1406 18.2812C83.1719 18.2812 81.6367 17.6953 80.5352 16.5234C79.4336 15.3438 78.8828 13.7031 78.8828 11.6016C78.8828 9.5 79.4375 7.83984 80.5469 6.62109C81.6562 5.40234 83.1719 4.79297 85.0938 4.79297C87 4.79297 88.4844 5.36719 89.5469 6.51562C90.6172 7.66406 91.1523 9.26562 91.1523 11.3203V12.3633H82.2812V12.5391C82.3047 13.5 82.5781 14.2617 83.1016 14.8242C83.6328 15.3789 84.3438 15.6562 85.2344 15.6562C85.9062 15.6562 86.4688 15.543 86.9219 15.3164C87.375 15.082 87.6914 14.75 87.8711 14.3203ZM94.9258 2.00391H98.3359V5.20312H101.02V7.88672H98.3359V13.6992C98.3359 14.2617 98.4688 14.6758 98.7344 14.9414C99.0078 15.207 99.4336 15.3398 100.012 15.3398C100.395 15.3398 100.73 15.3242 101.02 15.293V17.8945C100.496 17.9961 99.9258 18.0469 99.3086 18.0469C97.7383 18.0469 96.6133 17.7734 95.9336 17.2266C95.2617 16.6797 94.9258 15.7734 94.9258 14.5078V7.88672H92.9102V5.20312H94.9258V2.00391ZM109.762 8.87109C109.762 7.64453 110.254 6.66016 111.238 5.91797C112.23 5.16797 113.531 4.79297 115.141 4.79297C116.781 4.79297 118.066 5.125 118.996 5.78906C119.934 6.45312 120.449 7.40234 120.543 8.63672H117.391C117.305 8.21484 117.066 7.88672 116.676 7.65234C116.293 7.41016 115.789 7.28906 115.164 7.28906C114.547 7.28906 114.039 7.41797 113.641 7.67578C113.242 7.92578 113.043 8.25391 113.043 8.66016C113.043 8.97266 113.184 9.23438 113.465 9.44531C113.746 9.64844 114.188 9.81641 114.789 9.94922L117.215 10.4766C118.473 10.75 119.391 11.168 119.969 11.7305C120.555 12.293 120.848 13.0547 120.848 14.0156C120.848 15.2969 120.324 16.3281 119.277 17.1094C118.23 17.8906 116.855 18.2812 115.152 18.2812C113.449 18.2812 112.102 17.9453 111.109 17.2734C110.117 16.6016 109.562 15.6445 109.445 14.4023H112.773C113.047 15.3242 113.863 15.7852 115.223 15.7852C115.887 15.7852 116.426 15.6602 116.84 15.4102C117.254 15.1523 117.461 14.8164 117.461 14.4023C117.461 14.082 117.332 13.8242 117.074 13.6289C116.816 13.4258 116.402 13.2617 115.832 13.1367L113.488 12.6094C112.23 12.3359 111.293 11.8945 110.676 11.2852C110.066 10.668 109.762 9.86328 109.762 8.87109ZM124.551 2.00391H127.961V5.20312H130.645V7.88672H127.961V13.6992C127.961 14.2617 128.094 14.6758 128.359 14.9414C128.633 15.207 129.059 15.3398 129.637 15.3398C130.02 15.3398 130.355 15.3242 130.645 15.293V17.8945C130.121 17.9961 129.551 18.0469 128.934 18.0469C127.363 18.0469 126.238 17.7734 125.559 17.2266C124.887 16.6797 124.551 15.7734 124.551 14.5078V7.88672H122.535V5.20312H124.551V2.00391ZM138.156 15.6328C138.945 15.6328 139.605 15.4102 140.137 14.9648C140.668 14.5195 140.934 13.9688 140.934 13.3125V12.3633L138.32 12.5273C136.867 12.6289 136.141 13.1484 136.141 14.0859C136.141 14.5625 136.324 14.9414 136.691 15.2227C137.066 15.4961 137.555 15.6328 138.156 15.6328ZM137.031 18.1992C135.781 18.1992 134.762 17.8438 133.973 17.1328C133.191 16.4219 132.801 15.4805 132.801 14.3086C132.801 13.1445 133.23 12.2305 134.09 11.5664C134.957 10.8945 136.195 10.5117 137.805 10.418L140.934 10.2305V9.17578C140.934 8.63672 140.746 8.22266 140.371 7.93359C139.996 7.63672 139.457 7.48828 138.754 7.48828C137.488 7.48828 136.711 7.88672 136.422 8.68359H133.281C133.391 7.48828 133.953 6.54297 134.969 5.84766C135.992 5.14453 137.316 4.79297 138.941 4.79297C140.645 4.79297 141.961 5.17578 142.891 5.94141C143.828 6.70703 144.297 7.78516 144.297 9.17578V18H140.992V16.3125H140.781C140.445 16.9062 139.945 17.3711 139.281 17.707C138.617 18.0352 137.867 18.1992 137.031 18.1992ZM147.648 18V5.07422H150.953V7.13672H151.164C151.336 6.48047 151.727 5.9375 152.336 5.50781C152.953 5.07812 153.668 4.86328 154.48 4.86328C155.066 4.86328 155.512 4.91797 155.816 5.02734V8.13281C155.457 7.99219 154.918 7.92188 154.199 7.92188C153.254 7.92188 152.492 8.18359 151.914 8.70703C151.344 9.23047 151.059 9.94141 151.059 10.8398V18H147.648ZM159.613 2.00391H163.023V5.20312H165.707V7.88672H163.023V13.6992C163.023 14.2617 163.156 14.6758 163.422 14.9414C163.695 15.207 164.121 15.3398 164.699 15.3398C165.082 15.3398 165.418 15.3242 165.707 15.293V17.8945C165.184 17.9961 164.613 18.0469 163.996 18.0469C162.426 18.0469 161.301 17.7734 160.621 17.2266C159.949 16.6797 159.613 15.7734 159.613 14.5078V7.88672H157.598V5.20312H159.613V2.00391ZM174.051 7.40625C173.262 7.40625 172.609 7.66016 172.094 8.16797C171.586 8.67578 171.301 9.34766 171.238 10.1836H176.746C176.707 9.32422 176.445 8.64844 175.961 8.15625C175.484 7.65625 174.848 7.40625 174.051 7.40625ZM176.816 14.3203H179.992C179.734 15.5469 179.078 16.5156 178.023 17.2266C176.977 17.9297 175.664 18.2812 174.086 18.2812C172.117 18.2812 170.582 17.6953 169.48 16.5234C168.379 15.3438 167.828 13.7031 167.828 11.6016C167.828 9.5 168.383 7.83984 169.492 6.62109C170.602 5.40234 172.117 4.79297 174.039 4.79297C175.945 4.79297 177.43 5.36719 178.492 6.51562C179.562 7.66406 180.098 9.26562 180.098 11.3203V12.3633H171.227V12.5391C171.25 13.5 171.523 14.2617 172.047 14.8242C172.578 15.3789 173.289 15.6562 174.18 15.6562C174.852 15.6562 175.414 15.543 175.867 15.3164C176.32 15.082 176.637 14.75 176.816 14.3203ZM187.527 18.1992C185.902 18.1992 184.617 17.6016 183.672 16.4062C182.734 15.2109 182.266 13.582 182.266 11.5195C182.266 9.46484 182.734 7.84375 183.672 6.65625C184.617 5.46094 185.902 4.86328 187.527 4.86328C188.402 4.86328 189.18 5.06641 189.859 5.47266C190.539 5.87109 191.047 6.42578 191.383 7.13672H191.582V0.140625H194.992V18H191.688V15.9727H191.477C191.133 16.668 190.613 17.2148 189.918 17.6133C189.223 18.0039 188.426 18.1992 187.527 18.1992ZM190.832 8.75391C190.309 8.06641 189.594 7.72266 188.688 7.72266C187.781 7.72266 187.066 8.0625 186.543 8.74219C186.027 9.41406 185.77 10.3438 185.77 11.5312C185.77 12.7266 186.027 13.6641 186.543 14.3438C187.059 15.0156 187.773 15.3516 188.688 15.3516C189.602 15.3516 190.316 15.0156 190.832 14.3438C191.355 13.6641 191.617 12.7305 191.617 11.543C191.617 10.3633 191.355 9.43359 190.832 8.75391Z" fill="#333333" />
                                    </svg>}

                                </Box>

                                <Box className='inputsContainer'>

                                    {(twoFactor?.required || showOtpScreen) && <OTPVerification onBack={() => setShowOtpScreen(false)} />}

                                    {!twoFactor?.required && !showOtpScreen && <>
                                    {!isForgetPassword &&
                                        <Box noValidate >
                                            <lebel class="inputLebels">Email Address</lebel>
                                            <TextField className='inputBox'
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        paddingRight: 0,
                                                        backgroundColor: color.grey.Gray4,
                                                        borderRadius: '8px'
                                                    },
                                                }}
                                                placeholder='john@domain.com'
                                                size='small'
                                                error={errorType === "email"}
                                                helperText={errorType === "email" ? "Invalid email" : ""}
                                                margin="normal"
                                                required
                                                fullWidth
                                                id="email"
                                                // label="Email Address"
                                                name="email"
                                                autoComplete=""
                                                value={email}
                                                onChange={(e) => {
                                                    const email = e.target.value;
                                                    setEmail(email);
                                                    setErrorType("")
                                                }}
                                                autoFocus
                                            />

                                            <lebel class="inputLebels">Password</lebel>
                                            <Button className='forgotPasswordLink' size="small" variant="text" sx={[{
                                                float: 'right',
                                                padding: 0,
                                                '&:hover': {
                                                    color: 'green',
                                                    backgroundColor: 'white',
                                                },
                                                textTransform: 'none'
                                            }]} onClick={gotToForgotPassword}>Forgot Password?
                                            </Button>
                                            <TextField
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        paddingRight: 0,
                                                        backgroundColor: color.grey.Gray4,
                                                        borderRadius: '8px'
                                                    },
                                                }}
                                                className='inputBox'
                                                placeholder='********'
                                                size='small'
                                                margin="normal"
                                                error={errorType === "password"}
                                                helperText={errorType === "password" ? "Invalid password" : ""}
                                                required
                                                fullWidth
                                                name="password"
                                                type={showPassword ? 'text' : 'password'}
                                                id="password"
                                                autoComplete=""
                                                value={password}
                                                onChange={(e) => {
                                                    const password = e.target.value;
                                                    setPassword(password);
                                                    setErrorType("");
                                                }}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end" >
                                                            <IconButton
                                                                aria-label="toggle password visibility"
                                                                onClick={() => setShowPassword(!showPassword)}
                                                                onMouseDown={(e) => e.preventDefault()}
                                                                style={{ backgroundColor: '#ebebeb' }}
                                                            >
                                                                {showPassword ? <i class="ph ph-eye"></i> : <i class="ph ph-eye-closed"></i>}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                            <Button className='signInBtn'
                                                type="submit"
                                                fullWidth
                                                variant="contained"
                                                disabled={!isOnline}
                                            >
                                                Sign In
                                            </Button>
                                        </Box>
                                    }
                                    {isForgetPassword &&
                                        <Box noValidate >
                                            <lebel class="inputLebels">Email Address</lebel>
                                            <TextField className='inputBox'
                                                placeholder='john@domain.com'
                                                size='small'
                                                error={errorType === "email"}
                                                helperText={errorType === "email" ? "Invalid email" : ""}
                                                margin="normal"
                                                required
                                                fullWidth
                                                id="email"
                                                // label="Email Address"
                                                name="email"
                                                autoComplete=""
                                                value={resetPassEmail}
                                                onChange={(e) => {
                                                    const resetPassEmail = e.target.value;
                                                    setResetPassEmail(resetPassEmail);
                                                    setErrorType("")
                                                }}
                                                autoFocus
                                            />

                                            <Button
                                                className='requestPasswordBtn'
                                                type="button"
                                                fullWidth
                                                variant="contained"
                                                sx={{ mt: 3, mb: 2 }}
                                                onClick={requestPassword}
                                            >
                                                Request Password
                                            </Button>

                                            <Box sx={{ textAlign: 'center' }}>
                                                <Button className='forgotPasswordLink' size="small" variant="text" sx={[{
                                                    '&:hover': {
                                                        color: 'green',
                                                        backgroundColor: 'white',
                                                    },
                                                    textTransform: 'none'
                                                }]} onClick={gotToLogin}>Sign In
                                                </Button>
                                            </Box>

                                        </Box>
                                    }
                                    </>}

                                </Box>

                            </Container>
                        </Box>
                    </Box>


                    {/* Copyright part */}
                    <Box className='loginFooter' sx={{ width: '100%', position: 'absolute', zIndex: 999 }}>
                        <Copyright />
                    </Box>

                </Grid>

                {/* Skyline photo with an "Ask LodgIQ" promo band overlaid on top */}
                <Grid className='loginImage' item xs={false} sm={4} md={7}
                    sx={{
                        position: 'relative',
                        overflow: 'hidden',
                        backgroundImage: 'url(assets/img/login-img/seven.jpeg)',
                        backgroundRepeat: 'no-repeat',
                        backgroundColor: (t) =>
                            t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                    }}
                >
                    <AskLodgiqPromo />
                </Grid>

            </Grid>

        </ThemeProvider>
    );
};

const Login = () => {
    const recaptcha_site_key = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

    return (
        <GoogleReCaptchaProvider reCaptchaKey={recaptcha_site_key}>
            <LoginContent />
        </GoogleReCaptchaProvider>
    );
};

export default Login;
